// This holds the practice logo, or default Updox logo

import React from 'react';
import { string } from 'prop-types';

import cx from 'classnames';
import s from './HeaderBranding.css';

const paths = [
  '/login',
  '/resetpassword',
  '/verifycode',
  '/verifydob',
  '/home',
];

// POR-668 - only display practice logo on the home page
const HeaderBranding = ({ ...props }) => {

  /**
   * Generates a logo image based on a provided logo URL which can either contain an actual URL, or
   * a keyword to indicate how to set the image's source.
   *
   * Scenarios:
   * 1. Logo URL starts with either http or https. Use that URL as the image source
   * 2. Logo URL is a keyword, therefore, locate relative path logo based on keyword
   * 3. Logo URL does not meet any criteria, default to the UpDox logo
   */
  const renderLogo = () => {

    const id = "practice_logo";
    const altText = "Practice Logo";

    if (props.logoUrl) {

      if (props.logoUrl.indexOf('http') === 0) {
        return <img id={id} src={props.logoUrl} alt={altText} className={s.logoUrl}/>;
      }

      const logoUrlToLocation = {
        'emds': require('./logos/emds/logo.png'),
        'healthinmotion': require('./logos/healthinmotion/logo.png'),
        'firstinsight': require('./logos/firstinsight/logo.png'),
      };

      const logoLocation = logoUrlToLocation[props.logoUrl] || require('./logo-updox-2018.svg');
      return <img id={id} src={logoLocation} alt={altText} className={s.logoUrl}/>;

    }
    else {
      return <div className={s.branding} />;
    }
  };

  if (paths.indexOf(props.activeRoute) >= 0) {
    return (
      <section className={cx(s.component, props.className)}>
        {renderLogo()}
      </section>
    );
  }

  // If we don't match the path passed display an empty component
  return (
    <section className={cx(s.component, props.className)} />
  );

};

HeaderBranding.propTypes = {
  activeRoute: string,
  logoUrl: string,
  className: string,
};

export default HeaderBranding;



// WEBPACK FOOTER //
// ./src/components/HeaderBar/HeaderBranding.js